module.exports = __webpack_public_path__ + "img/nothingBlank.9b0b7f5e.png";